import {
  filterSubsectionsByName,
  mapBulletPointsWithIcon,
} from 'components/PageSections/utils';

import { ProductPromotionProps } from './ProductPromotion';

export default function parseProductPromotion(
  section: Queries.ContentfulSection001 | undefined | null,
): ProductPromotionProps {
  const subsections = section?.subsections as Queries.ContentfulSection001[];
  const productPromotionSection = filterSubsectionsByName(
    'BulletPointWithIcon',
    subsections,
  );
  const bulletPoints = mapBulletPointsWithIcon(productPromotionSection);

  return {
    body: section?.body || null,
    bulletPoints,
  };
}
